module.exports = __webpack_public_path__ + "static/img/s203.9853a8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s203.png
// module id = 545
// module chunks = 3